import React, { useEffect, useState } from 'react';
import { Search, X, ChevronLeft, ChevronRight } from 'lucide-react';
import { jwtDecode } from 'jwt-decode';
import { useApi } from '../utils/apiUtils';
import OpsLayout from '../components/OpsLayout';
import '../css/Operations.css';

const formatDate = (dateString) => {
    const date = new Date(dateString);
    return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')} ${String(date.getHours()).padStart(2, '0')}:${String(date.getMinutes()).padStart(2, '0')}`;
};

const ClientModal = ({ client, onClose, api }) => {
    const [editedClient, setEditedClient] = useState(client);
    const [showPasswordChange, setShowPasswordChange] = useState(false);
    const [passwordData, setPasswordData] = useState({
        currentPassword: '',
        newPassword: '',
        confirmPassword: ''
    });
    const [passwordError, setPasswordError] = useState('');

    // 로그인 정보
    let adminInfoRaw = {};
    try {
        adminInfoRaw = JSON.parse(localStorage.getItem('adminInfo') || '{}');
    } catch (e) {}
    const adminInfo = adminInfoRaw.adminInfo || adminInfoRaw;
    const isSuperAdmin = adminInfoRaw.isSuperAdmin || adminInfo?.user_role === 'SUPER_ADMIN';
    const loggedInUserId = adminInfo?.id;
    const loggedInUserEmail = adminInfo?.user_email;
    // 비밀번호 변경 모달 상태
    const [showPasswordModal, setShowPasswordModal] = useState(false);
    const [newPassword, setNewPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    // 노출 조건
    console.log('client.id:', client?.id, 'adminInfo.id:', loggedInUserId);
    console.log('client.email:', client?.email, 'adminInfo.user_email:', loggedInUserEmail);
    console.log('isSuperAdmin:', isSuperAdmin);
    const canChangePassword = isSuperAdmin || (
        client && (
            String(client.id) === String(loggedInUserId) ||
            String(client.email).toLowerCase() === String(loggedInUserEmail).toLowerCase()
        )
    );
    console.log('canChangePassword:', canChangePassword);

    useEffect(() => {
        setEditedClient(client);
    }, [client]);

    if (!client) return null;

    const handleChange = (e) => {
        const { name, value } = e.target;
        setEditedClient(prev => ({ ...prev, [name]: value }));
    };

    const handlePasswordChange = (e) => {
        const { name, value } = e.target;
        setPasswordData(prev => ({ ...prev, [name]: value }));
        setPasswordError('');
    };

    const validatePassword = () => {
        if (passwordData.newPassword !== passwordData.confirmPassword) {
            setPasswordError('새 비밀번호가 일치하지 않습니다.');
            return false;
        }
        if (passwordData.newPassword.length < 8) {
            setPasswordError('비밀번호는 8자 이상이어야 합니다.');
            return false;
        }
        return true;
    };

    const validateNewPassword = () => {
        if (newPassword !== confirmPassword) {
            alert('새 비밀번호가 일치하지 않습니다.');
            return false;
        }
        if (newPassword.length < 8) {
            alert('비밀번호는 8자 이상이어야 합니다.');
            return false;
        }
        return true;
    };

    const handlePasswordUpdate = async () => {
        if (!validateNewPassword()) {
            return;
        }

        try {
            const updateData = {
                newPassword: newPassword
            };

            // 현재 로그인한 사용자의 비밀번호를 변경하는 경우
            if (String(client.id) === String(loggedInUserId) || 
                String(client.email).toLowerCase() === String(loggedInUserEmail).toLowerCase()) {
                // 자신의 비밀번호 변경 - 현재 비밀번호 확인 필요
                updateData.currentPassword = passwordData.currentPassword;
            }

            await api.put(`/api/operations/${client.id}/password`, updateData);
            alert('비밀번호가 성공적으로 변경되었습니다.');
            setShowPasswordModal(false);
            setNewPassword('');
            setConfirmPassword('');
            setPasswordData({
                currentPassword: '',
                newPassword: '',
                confirmPassword: ''
            });
        } catch (error) {
            console.error('Failed to update password:', error);
            alert(error.response?.data?.message || '비밀번호 변경 중 오류가 발생했습니다.');
        }
    };

    const handleSave = async () => {
        try {
            const token = localStorage.getItem('token');
            const updateData = {
                name: editedClient.name,
                email: editedClient.email,
                mobile: editedClient.mobile
            };

            // 비밀번호 변경이 요청된 경우
            if (showPasswordChange) {
                if (!validatePassword()) {
                    return;
                }
                updateData.currentPassword = passwordData.currentPassword;
                updateData.newPassword = passwordData.newPassword;
            }

            await api.put(`/api/operations/${client.id}`, updateData, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });
            alert('저장이 완료되었습니다.');
            window.location.reload();
        } catch (error) {
            console.error('Failed to update client:', error);
            alert(error.response?.data?.message || '저장 중 오류가 발생했습니다.');
        }
    };
    
    return (
        <div className="sds-modal-overlay" onClick={onClose}>
            <div className="sds-modal" onClick={(e) => e.stopPropagation()} role="dialog" aria-modal="true" aria-labelledby="admin-detail-title">
                <div className="sds-modal__head">
                    <h2 id="admin-detail-title" className="sds-modal__title">관리자 상세</h2>
                    <button className="sds-btn sds-btn--ghost sds-btn--sm" onClick={onClose} aria-label="닫기"><X size={16} aria-hidden="true" /></button>
                </div>
                <div className="sds-modal__body">
                    <dl className="ops-page__kv">
                        <dt>이름</dt><dd>{editedClient.name}</dd>
                        <dt>이메일</dt><dd>{editedClient.email}</dd>
                        <dt>전화번호</dt><dd>{editedClient.mobile}</dd>
                        <dt>수정일시</dt><dd>{formatDate(editedClient.created_at)}</dd>
                        <dt>소속권역(병원명)</dt><dd>{client.institution_name || ''}</dd>
                        <dt>소속기관(주소)</dt><dd>{client.address || ''}</dd>
                    </dl>

                    {/* 비밀번호 변경 섹션 */}
                    {/* <button
                        onClick={() => setShowPasswordChange(!showPasswordChange)}
                        className="sds-btn sds-btn--secondary"
                    >
                        {showPasswordChange ? '비밀번호 변경 취소' : '비밀번호 변경'}
                    </button> */}

                    {showPasswordChange && (
                        <div className="admins-page__password-fields">
                            <div className="sds-field">
                                <label className="sds-label">현재 비밀번호</label>
                                <input
                                    type="password"
                                    name="currentPassword"
                                    value={passwordData.currentPassword}
                                    onChange={handlePasswordChange}
                                    className="sds-input"
                                />
                            </div>
                            <div className="sds-field">
                                <label className="sds-label">새 비밀번호</label>
                                <input
                                    type="password"
                                    name="newPassword"
                                    value={passwordData.newPassword}
                                    onChange={handlePasswordChange}
                                    className="sds-input"
                                />
                            </div>
                            <div className="sds-field">
                                <label className="sds-label">새 비밀번호 확인</label>
                                <input
                                    type="password"
                                    name="confirmPassword"
                                    value={passwordData.confirmPassword}
                                    onChange={handlePasswordChange}
                                    className="sds-input"
                                />
                            </div>
                            {passwordError && <p className="sds-field-error">{passwordError}</p>}
                        </div>
                    )}
                </div>
                <div className="sds-modal__foot">
                    {canChangePassword && <button className="sds-btn sds-btn--weak" onClick={() => setShowPasswordModal(true)}>비밀번호 변경</button>}
                    <span className="sds-toolbar__spacer" />
                    <button className="sds-btn sds-btn--secondary" onClick={onClose}>닫기</button>
                    <button className="sds-btn sds-btn--primary" onClick={handleSave}>저장</button>
                </div>

                {/* 비밀번호 변경 모달 */}
                {showPasswordModal && (
                    <div className="sds-modal-overlay" onClick={() => setShowPasswordModal(false)}>
                        <div className="sds-modal" onClick={(e) => e.stopPropagation()} role="dialog" aria-modal="true" aria-labelledby="admin-password-title">
                            <div className="sds-modal__head">
                                <h2 id="admin-password-title" className="sds-modal__title">비밀번호 변경</h2>
                                <button className="sds-btn sds-btn--ghost sds-btn--sm" onClick={() => setShowPasswordModal(false)} aria-label="닫기"><X size={16} aria-hidden="true" /></button>
                            </div>
                            <div className="sds-modal__body">
                                {/* 자신의 비밀번호를 변경하는 경우에만 현재 비밀번호 입력 */}
                                {(String(client.id) === String(loggedInUserId) ||
                                  String(client.email).toLowerCase() === String(loggedInUserEmail).toLowerCase()) && (
                                    <div className="sds-field">
                                        <label className="sds-label">현재 비밀번호</label>
                                        <input
                                            type="password"
                                            className="sds-input"
                                            placeholder="현재 비밀번호"
                                            value={passwordData.currentPassword}
                                            onChange={e => setPasswordData(prev => ({ ...prev, currentPassword: e.target.value }))}
                                        />
                                    </div>
                                )}
                                <div className="sds-field">
                                    <label className="sds-label">새 비밀번호</label>
                                    <input
                                        type="password"
                                        className="sds-input"
                                        placeholder="새 비밀번호"
                                        value={newPassword}
                                        onChange={e => setNewPassword(e.target.value)}
                                    />
                                </div>
                                <div className="sds-field">
                                    <label className="sds-label">비밀번호 확인</label>
                                    <input
                                        type="password"
                                        className="sds-input"
                                        placeholder="비밀번호 확인"
                                        value={confirmPassword}
                                        onChange={e => setConfirmPassword(e.target.value)}
                                    />
                                </div>
                            </div>
                            <div className="sds-modal__foot">
                                <button className="sds-btn sds-btn--secondary" onClick={() => setShowPasswordModal(false)}>취소</button>
                                <button className="sds-btn sds-btn--primary" onClick={handlePasswordUpdate}>저장</button>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default function Operations() {
    const [clients, setClients] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const [selectedClient, setSelectedClient] = useState(null);
    const [currentPage, setCurrentPage] = useState(1);
    const clientsPerPage = 5;
    const [filterType, setFilterType] = useState('all');
    const api = useApi();

    // 예시: 로그인 정보(실제 구현에 맞게 수정)
    let adminInfoRaw = {};
    try {
        adminInfoRaw = JSON.parse(localStorage.getItem('adminInfo') || '{}');
    } catch (e) {}
    const adminInfo = adminInfoRaw.adminInfo || adminInfoRaw;
    const isSuperAdmin = adminInfoRaw.isSuperAdmin || adminInfo?.user_role === 'SUPER_ADMIN';
    const loggedInUserId = adminInfo?.id;
    const loggedInUserEmail = adminInfo?.user_email;

    useEffect(() => {
        const handleFilterChange = (event) => {
            setFilterType(event.detail.type);
        };
        window.addEventListener('filterChange', handleFilterChange);
        return () => window.removeEventListener('filterChange', handleFilterChange);
    }, []);

    useEffect(() => {
        fetchClients();
    }, [filterType]);

    const fetchClients = async () => {
        try {
            const user = JSON.parse(localStorage.getItem('user'));
            const hospitalId = user?.hospital_id || localStorage.getItem('hospital_id');
            const regionCode = user?.region_code || localStorage.getItem('region_code');
            const districtCode = user?.district_code || localStorage.getItem('district_code');
            const isSuperAdmin = user?.is_super_admin === 'true' || localStorage.getItem('is_super_admin') === 'true';
            const params = {
                search: searchTerm,
                hospital_id: hospitalId,
                region_code: regionCode,
                district_code: districtCode,
                is_super_admin: isSuperAdmin ? 'true' : undefined
            };
            console.log('API 요청 파라미터:', params);
            const response = await api.get('/api/operations', params);

            // Transform response data to match component's expected format
            const admins = (response && Array.isArray(response.data)) ? response.data : [];
            const transformedData = admins
                .filter(admin => 
                    // SUPER_ADMIN 제외
                    admin.user_role !== 'SUPER_ADMIN' &&
                    // 검색어 필터링
                    (!searchTerm || 
                    (admin.user_name && admin.user_name.toLowerCase().includes(searchTerm.toLowerCase())))
                )
                .map(admin => ({
                    id: admin.id,
                    name: admin.user_name,
                    email: admin.user_email, 
                    mobile: admin.user_mobile,
                    role: admin.user_role,
                    created_at: admin.created_at,
                    institution_name: admin.institution_name || '',
                    address: admin.address || '',
                    status: admin.status,
                    affiliation: admin.affiliation,
                    organization: admin.organization
                }));

            setClients(transformedData);
            setCurrentPage(1);
            
        } catch (error) {
            console.error('Failed to fetch admin data:', error);
            if (error.response?.status === 401) {
                alert('인증이 만료되었습니다. 다시 로그인해주세요.');
            } else {
                alert('관리자 데이터를 불러오는데 실패했습니다.');
            }
        }
    };

    const handleSearchChange = (e) => {
        setSearchTerm(e.target.value);
    };

    const handleSearch = () => {
        fetchClients();
    };

    const handleKeyPress = (e) => {
        if (e.key === 'Enter') {
            handleSearch();
        }
    };

    const handleClientClick = (client) => {
        setSelectedClient(client);
    };

    const handleCloseModal = () => {
        setSelectedClient(null);
    };

    const indexOfLastClient = currentPage * clientsPerPage;
    const indexOfFirstClient = indexOfLastClient - clientsPerPage;
    const currentClients = clients.slice(indexOfFirstClient, indexOfLastClient);

    const totalPages = Math.ceil(clients.length / clientsPerPage);

    const handlePreviousPage = () => {
        if (currentPage > 1) {
            setCurrentPage(currentPage - 1);
        }
    };

    const handleNextPage = () => {
        if (currentPage < totalPages) {
            setCurrentPage(currentPage + 1);
        }
    };

    return (
        <OpsLayout title="관리자 목록" description="센터에 등록된 관리자 계정이에요. 행을 누르면 상세를 볼 수 있어요.">
            <section className="ops-page__card admins-page">
                <div className="sds-toolbar">
                    <div className="sds-input-group">
                        <Search size={16} aria-hidden="true" />
                        <input
                            type="text"
                            className="sds-input"
                            placeholder="이름으로 검색..."
                            value={searchTerm}
                            onChange={handleSearchChange}
                            onKeyPress={handleKeyPress}
                        />
                    </div>
                    <button className="sds-btn sds-btn--secondary" onClick={handleSearch}>검색</button>
                </div>
                <div className="sds-table-wrap">
                    <table className="sds-table">
                        <thead>
                            <tr>
                                <th>번호</th>
                                <th>권한</th>
                                <th>이름</th>
                                <th>이메일</th>
                                <th>연락처</th>
                            </tr>
                        </thead>
                        <tbody>
                            {currentClients.sort((a, b) => a.id - b.id).map((client, index) => (
                                <tr key={index} onClick={() => handleClientClick(client)} className="ops-page__row--clickable">
                                    <td>{client.id}</td>
                                    <td>{client.role}</td>
                                    <td>{client.name}</td>
                                    <td>{client.email}</td>
                                    <td>{client.mobile}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
                <div className="sds-pagination">
                    <button
                        onClick={handlePreviousPage}
                        disabled={currentPage === 1}
                        className="sds-pagination__btn"
                        aria-label="이전 페이지"
                    >
                        <ChevronLeft size={16} aria-hidden="true" />
                    </button>
                    {Array.from({ length: totalPages }, (_, i) => i + 1).map((page) => (
                        <button
                            key={page}
                            onClick={() => setCurrentPage(page)}
                            className={`sds-pagination__btn${currentPage === page ? ' is-active' : ''}`}
                            aria-current={currentPage === page ? 'page' : undefined}
                        >
                            {page}
                        </button>
                    ))}
                    <button
                        onClick={handleNextPage}
                        disabled={currentPage >= totalPages}
                        className="sds-pagination__btn"
                        aria-label="다음 페이지"
                    >
                        <ChevronRight size={16} aria-hidden="true" />
                    </button>
                </div>
                {selectedClient && <ClientModal client={selectedClient} onClose={handleCloseModal} api={api} />}
            </section>
        </OpsLayout>
    );
}
